export default __webpack_public_path__ + "static/media/lets-go-bro.56e9ecc8.gif";